/* eslint-disable import/prefer-default-export */
// page-route to page id mapping for Symphony
// Once all the page ids are on boarded, page id will be served from the backend

import {
  CAPACITY_MANAGEMENT_PARTNER_PICKER_PATH,
  CASE_MANAGEMENT_PATH,
  NPC_PATH,
  PARTNER_PICKER_PATH,
  PERFORMANCE_DASHBOARD_PATH,
  PERFORMANCE_INSIGHTS_PATH,
  RUBIKS_PATH,
} from '../config/navigationalRoutes';

export const ROUTE_MAPPING = {
  [PARTNER_PICKER_PATH]: 'forecast-home',
  [NPC_PATH]: 'npc-home',
  [PERFORMANCE_INSIGHTS_PATH]: 'insights-home',
  [PERFORMANCE_DASHBOARD_PATH]: 'dashboard-home',
  [CASE_MANAGEMENT_PATH]: 'case-mgnt-home',
  [CAPACITY_MANAGEMENT_PARTNER_PICKER_PATH]: 'capacity-home',
  [RUBIKS_PATH]: 'problem-solve-home',
};

export const DEFAULT_PAGE = 'home';

export const NPC_DEFAULT_STRATEGY = 'AMAZON_INITIATED';

export const NPC_STRATEGY_KEY = 'npcStrategy';
